import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams, Link as RouterLink } from 'react-router-dom'
import { api } from '../../../services/Main/Api'
import {
    Alert,
    Avatar,
    Backdrop,
    Box, Button,
    Card,
    CardContent, CardHeader, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    Divider,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
} from '@mui/material'
import { Helmet } from 'react-helmet'
import { useSnackbar } from 'notistack'
import Context from '../../../contexts/Context'
import CircularProgress from '@mui/material/CircularProgress'
import moment from 'moment/moment'
import {
    ContactMailOutlined, FileOpen, FileOpenOutlined, PowerSettingsNew, PriorityHigh,
} from '@mui/icons-material'
import Masks from '../../../components/Shared/Masks'
import useClipboard from '../../../hooks/useClipboard'
import SimpleTypography from "../../../components/Shared/SimpleTypography";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";


const CompanyDetail = () => {
    const { filters, setFilters, loadingModal, setLoadingModal } = useContext(Context)

    const params = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [reqData, setReqData] = useState()
    const [reqDataBank, setReqDataBank] = useState()
    const [isSaving, setIsSaving] = useState(false)
    const [open, setOpen] = React.useState(false);
    const [openDeactivate, setOpenDeactivate] = React.useState(false);
    const {enqueueSnackbar} = useSnackbar()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    async function cancelAccountBank() {
        try {
            const dataReq = {
                ...reqDataBank,
            };

            await api.put(`/fitbank/${params.id}/`, dataReq);
            enqueueSnackbar('Conta cancelada com sucesso!', { variant: 'success' });
        } catch (error) {
            enqueueSnackbar(error.response.data, { variant: 'error' });
            console.log(error);
        }
    }



    const handleConfirm = () => {
        cancelAccountBank();
        setOpen(false);
    };


    const getcompanyId = async () => {
        setIsLoading(true)
        setIsSaving(true)
        const url = `condo/${params.id}/`
        let result = await api.get(url).then(response => {
            console.log(response.data)
            setReqData(response.data)
            setIsLoading(false)
            setIsSaving(false)
        })
    }


    const getAccountBankCompany = async () => {
        setIsLoading(true);
        setIsSaving(true);
        const url = `fitbank/${params.id}/`;
        try {
            const response = await api.get(url);
            console.log(response.data);
            if (JSON.stringify(response.data) !== JSON.stringify(reqDataBank)) {
                setReqDataBank(response.data);
            }

        } catch (error) {
            console.log(error);
            enqueueSnackbar("Não foi possível obter informações da conta.", { variant: "error" });
        } finally {
            setIsLoading(false);
            setIsSaving(false);
        }
    };

    useEffect(() => {

        getcompanyId();
        getAccountBankCompany();
        window.scrollTo(0, 0)


    }, [])

    useEffect(() => {
        // Garante que só será executado se houver uma "mudança relevante"
        if (reqDataBank?.close_account_status) {
            getAccountBankCompany();
        }
    }, [reqDataBank?.close_account_status]);


    const formatCep = (cep) => {
        const match = cep.match(/^(\d{2})(\d{3})(\d{3})$/);
        if (match) {
            return `${match[1]}.${match[2]}-${match[3]}`;
        }
        return cep;
    };

    console.log('reqDataBank', reqDataBank)

    async function connectPlugSign() {
        try {
            const response = await api.post('/company/connect-plugsign/', {
                company: params.id,
            });

            console.log('Resposta:', response.data);

            // Atualiza os dados da empresa após conexão
            getcompanyId(); // talvez esse nome devesse ser getCompany ou fetchCompany?

            return response.data;
        } catch (error) {
            console.error('Erro ao conectar PlugSign:', error.response?.data || error.message);
            throw error;
        }
    }


    async function toggleCompanyStatus() {
        try {
            setLoadingModal(true)
            const newStatus = reqData?.status === 'Desativado' ? 'ACTIVE' : 'INACTIVE'
            await api.patch(`/condo/${params.id}/`, { status: newStatus })
            enqueueSnackbar(
                newStatus === 'INACTIVE'
                    ? 'Empresa desativada com sucesso!'
                    : 'Empresa ativada com sucesso!',
                { variant: 'success' }
            )
            getcompanyId()
        } catch (error) {
            enqueueSnackbar(
                error?.response?.data?.detail || 'Erro ao alterar status da empresa.',
                { variant: 'error' }
            )
        } finally {
            setLoadingModal(false)
            setOpenDeactivate(false)
        }
    }

    return (
        <>

            <Helmet>
                <title>Invoice - Bloco B3</title>
            </Helmet>
            <Backdrop
                sx={{ color: '#fff', zIndex: 1500, }}
                open={loadingModal}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>

            {/*{!isLoading &&*/}
            { reqData &&
                <Grid
                    container
                    spacing={2}
                    justifyContent={'space-between'}
                    sx={{ flexGrow: 1, padding: "1rem"  }}
                >

                    <Grid md={8}>
                        <Card
                            sx={{padding:"1rem", marginBottom: "3rem" }}>
                            { !isLoading &&
                                <>
                                    <CardContent>
                                        <Grid
                                            container
                                            spacing={2}
                                            justifyContent={'space-between'}
                                            sx={{flexGrow: 1}}
                                        >
                                            <Grid xs={6}>
                                                <Box>
                                                    <Typography variant="h6" sx={{
                                                        color: 'primary.main'
                                                    }}>Dados da Empresa</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid xs={6}>
                                                <Box
                                                    border
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'end',
                                                        alignItems: 'center'

                                                    }}
                                                >
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        color={reqData?.status === 'Desativado' ? 'success' : 'error'}
                                                        startIcon={<PowerSettingsNew />}
                                                        onClick={() => setOpenDeactivate(true)}
                                                    >
                                                        {reqData?.status === 'Desativado' ? 'Ativar Empresa' : 'Desativar Empresa'}
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <Divider/>
                                    <Box display="flex">
                                        <Grid xs={7}>
                                        <Box marginTop={'2rem'} marginRight={'2rem'} justifyContent="space-between">

                                            <SimpleTypography
                                                label={'Status:'}
                                                directValue={reqData?.status}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Razão Social:'}
                                                directValue={reqData?.legal_name}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Cnpj/Cpf:'}
                                                directValue={reqData?.cnpj?.length <= 14 ? Masks.cpf(reqData?.cnpj ?? '') : Masks.cnpj(reqData?.cnpj ?? '')}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Nome da Empresa:'}
                                                directValue={reqData?.name}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />


                                            <SimpleTypography
                                                label={'Telefone:'}
                                                directValue={reqData?.phone ? Masks?.phone(reqData?.phone): ''}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'E-mail:'}
                                                directValue={reqData?.email}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Endereço:'}
                                                directValue={`${reqData?.street}, ${reqData?.number}  ${reqData?.complement ? reqData?.complement : ''}`}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Bairro:'}
                                                directValue={reqData?.district}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Cidade:'}
                                                directValue={`${reqData?.city} - ${reqData.state}`}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Cep:'}
                                                directValue={formatCep(reqData?.cep)}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Tipo da Empresa:'}
                                                directValue={reqData?.type}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Modo de Referencia:'}
                                                directValue={reqData?.reference_mode_company}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Permitir Whatsapp:'}
                                                directValue={reqData?.whatsapp_send_message ? 'Sim' : 'Não'}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Nome no Whatsapp:'}
                                                directValue={reqData?.whatsapp_name ? reqData?.whatsapp_name : '-'}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />


                                        </Box>
                                        </Grid>
                                        <Grid xs={5}>
                                        <Box marginTop={'2rem'} justifyContent="space-between">

                                            <SimpleTypography
                                                label={'Tipo da Empresa:'}
                                                directValue={reqData?.type_description}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Plano:'}
                                                directValue={reqData?.type_plan}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <Button
                                                size="small"
                                                variant="outlined"
                                                component={RouterLink}
                                                to={`/admin/company/${params.id}/plano`}
                                                sx={{ mb: '1rem' }}
                                            >
                                                Gerenciar Plano
                                            </Button>

                                            <SimpleTypography
                                                label={'Bonificação:'}
                                                directValue={reqData?.bonus ? 'Sim' : 'Não'}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Preço do Plano:'}
                                                directValue={Masks.money(reqData?.plan_price.toString())}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Preço Ted:'}
                                                directValue={Masks.money(reqData?.ted_fee.toString())}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Preço Pix:'}
                                                directValue={Masks.money(reqData?.pix_fee.toString())}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Debito Automático:'}
                                                directValue={reqData?.auto_debit ? 'Sim' : 'Não'}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Método de Pagamento:'}
                                                directValue={reqData.payment_method}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Preço por Cobrança:'}
                                                directValue={reqData.price_per_charge}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Preço por Fatura:'}
                                                directValue={reqData.price_per_invoice}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Número da Prévia do Contrato:'}
                                                directValue={reqData.preview_of_number_contract}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                        <SimpleTypography
                                            label={'Data de Início:'}
                                            directValue={moment(reqData?.created_at).format('DD/MM/YYYY')}
                                            labelStyles={{
                                                fontWeight: 'bold',
                                                marginRight: '1rem'
                                            }}
                                            boxStyles={{
                                                width: '100%',
                                                mb: '1rem'
                                            }}
                                        />
                                            <SimpleTypography
                                                label={'Data da última atualização:'}
                                                directValue={moment(reqData.updated_at).format('DD/MM/YYYY')}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />

                                            <SimpleTypography
                                                label={'Preço do Whatsapp:'}
                                                directValue={reqData?.whatsapp_fee ? Masks.money(reqData.whatsapp_fee.toString()) : ''}
                                                labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                                boxStyles={{ width: '100%', mb: '1rem' }}
                                            />


                                        </Box>
                                        </Grid>
                                    </Box>



                                </>
                            }

                        </Card>

                    </Grid>

                    <Grid md={4}>
                        <Card sx={{padding:"1rem", mx: "1rem" }}>
                            <CardContent>
                                <Box sx={{display: "flex", justifyContent: 'space-between'}}>
                                <Box sx={{display: "flex", alignItems: "center"}}>
                                    <AccountBalanceOutlinedIcon sx={{
                                        color: 'primary.main'
                                    }} />
                                    <Typography color={"primary.main"} sx={{marginLeft: ".5rem"}} variant="h6">
                                        Contas Bancárias</Typography>
                                </Box>
                                    { reqDataBank?.close_account_status?.key &&
                                <Box sx={{display: "flex", alignItems: "center"}}>
                                    <Typography  sx={{marginRight: ".5rem"}} variant="p">
                                        Encerramento:
                                    </Typography>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'end',
                                            // justifyContent: 'start'
                                        }}
                                    >

                                        <Chip
                                            color={reqDataBank?.close_account_status?.key === '1' ? 'secondary' :
                                                reqDataBank?.close_account_status?.key === '3' ? 'warning' :
                                                reqDataBank?.close_account_status?.key === '4' ? 'error' :
                                                reqDataBank?.close_account_status?.key === '5' ? 'success' :
                                                reqDataBank?.close_account_status?.key === '6' ? 'success' :
                                                reqDataBank?.close_account_status?.key === '7' ? 'info' :
                                                    reqDataBank?.close_account_status?.key === '2' ? 'error' : 'info'
                                            }
                                            size="small"
                                            variant="outlined"
                                            label={reqDataBank?.close_account_status?.value}/>


                                    </Box>
                                </Box>
                                    }
                                </Box>

                                    { reqDataBank?.close_account_status?.key &&
                                        <Box sx={{display: "flex", justifyContent: "flex-end", alignItems: "end"}}>
                                            <Typography sx={{fontSize: '0.80rem'}} variant="p">
                                                {reqDataBank?.close_account_message}
                                            </Typography>
                                        </Box>
                                    }

                                <Divider/>

                                {reqDataBank ? reqDataBank &&
                                <Box marginTop={'2rem'} justifyContent="space-between">

                                    <SimpleTypography
                                        label={'Banco:'}
                                        directValue={reqDataBank?.bank ? reqDataBank?.bank : '-'}
                                        labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                        boxStyles={{ width: '100%', mb: '1rem' }}
                                    />

                                    <SimpleTypography
                                        label={'Agencia:'}
                                        directValue={reqDataBank?.bank_branch ? reqDataBank?.bank_branch : '-'}
                                        labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                        boxStyles={{ width: '100%', mb: '1rem' }}
                                    />


                                    <SimpleTypography
                                        label={'Conta:'}
                                        directValue={`${reqDataBank?.bank_account ? reqDataBank?.bank_account : '-'} - ${reqDataBank?.bank_account_digit ? reqDataBank?.bank_account_digit : '-'}`}
                                        labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                        boxStyles={{ width: '100%', mb: '1rem' }}
                                    />

                                    <SimpleTypography
                                        label={'Spb Banco:'}
                                        directValue={reqDataBank?.spb_bank ? reqDataBank?.spb_bank : '-'}
                                        labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                        boxStyles={{ width: '100%', mb: '1rem' }}
                                    />

                                    <SimpleTypography
                                        label={'Spb Agencia:'}
                                        directValue={reqDataBank?.spb_bank_branch ? reqDataBank?.spb_bank_branch : '-'}
                                        labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                        boxStyles={{ width: '100%', mb: '1rem' }}
                                    />


                                    <SimpleTypography
                                        label={'Spb Conta:'}
                                        directValue={`${reqDataBank?.spb_bank_account ? reqDataBank.spb_bank_account : '-'} - ${reqDataBank?.spb_bank_account_digit ? reqDataBank?.spb_bank_account_digit : '-'}`}
                                        labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                        boxStyles={{ width: '100%', mb: '1rem' }}
                                    />

                                    <SimpleTypography
                                        label={'Chave da Conta:'}
                                        directValue={reqDataBank?.account_key ? reqDataBank.account_key : '-'}
                                        labelStyles={{ fontWeight: 'bold', marginRight: '1rem' }}
                                        boxStyles={{ width: '100%', mb: '1rem' }}
                                    />


                                </Box>
                                    :
                                    <Box>
                                        <Typography  sx={{marginRight: ".5rem", textAlign: "center",}} variant="h6">
                                            Conta Inexistente
                                        </Typography>
                                    </Box>
                                }
                            </CardContent>
                            <Divider/>
                            { reqDataBank &&
                            <Box sx={{display: 'flex', justifyContent: 'flex-end', mt: 2}}>
                                <Button
                                    size={'small'}
                                    variant="contained"
                                    color="primary"
                                    onClick={handleClickOpen}
                                    disabled={
                                      ["0", "1", "5", "6", "7"].includes(reqDataBank?.close_account_status?.key) ||
                                      reqData?.status !== "Desativado"
                                    }
                                >
                                    Encerrar Conta
                                </Button>
                            </Box>
                            }

                        </Card>

                        <Card sx={{ m: "1rem" }}>
                            <CardHeader sx={{color: "primary.main"}} title={"PlugSign"}
                                        avatar={
                                            <FileOpenOutlined />
                                        }
                            />
                            <Divider/>
                            <CardContent>
                                { reqData.plugsign_id ?
                                    "Sua conta está conectada!"
                                    :
                                    <Button variant={"outlined"} onClick={connectPlugSign} >Conectar ao PlugSign</Button>
                                }
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid md={12}>
                        <Card>
                            <CardHeader title={"Fitbank"} sx={{color: 'primary.main',  }} />
                            <Divider/>
                            <CardContent>
                                <Table>

                                    <TableBody>
                                        {reqData?.data_bank.map((row, index) => (
                                            <>
                                                <TableRow
                                                    key={index}
                                                >
                                                    <TableCell>
                                                        <strong>Identifier:</strong> {row.Identifier}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>TaxNumber:</strong> {row.TaxNumber}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>Name:</strong> {row.Name}
                                                    </TableCell>
                                                    <TableCell>
                                                        <strong>TradingName:</strong> {row.TradingName}
                                                    </TableCell>

                                                </TableRow>
                                                <TableRow
                                                    key={index}
                                                >

                                                    <TableCell >
                                                        <strong>Nickname:</strong> {row.Nickname}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>Mail:</strong> {row.Mail}
                                                    </TableCell>
                                                    <TableCell>
                                                        <strong>Phone:</strong> {row.Phone}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>FatherName:</strong> {row.FatherName}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow
                                                    key={index}
                                                >

                                                    <TableCell >
                                                        <strong>MotherName:</strong> {row.MotherName}
                                                    </TableCell>

                                                    <TableCell>
                                                        <strong>Nationality:</strong> {row.Nationality}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>BirthCity:</strong> {row.BirthCity}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>BirthState:</strong> {row.BirthState}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow
                                                    key={index}
                                                >
                                                    <TableCell>
                                                        <strong>Gender:</strong> {row.Gender}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>MaritalStatus:</strong> {row.MaritalStatus}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>SpouseName:</strong> {row.SpouseName}
                                                    </TableCell>
                                                    <TableCell>
                                                        <strong>Ocuppation:</strong> {row.Ocuppation}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow
                                                    key={index}
                                                >
                                                    <TableCell >
                                                        <strong>PubliclyExposedPerson:</strong> {row.PubliclyExposedPerson}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>CompanyType:</strong> {row.CompanyType}
                                                    </TableCell>

                                                    <TableCell>
                                                        <strong>CompanyActivity:</strong> {row.CompanyActivity}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>ConstitutionDate:</strong> {row.ConstitutionDate}
                                                    </TableCell>

                                                </TableRow>

                                                <TableRow
                                                    key={index}
                                                >
                                                    <TableCell>
                                                        <strong>AddressLine:</strong> {row.address[0].AddressLine}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>AddressLine2:</strong> {row.address[0].AddressLine2}
                                                    </TableCell>
                                                    <TableCell>
                                                        <strong>ZipCode:</strong> {row.address[0].ZipCode}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>Neighborhood:</strong> {row.address[0].Neighborhood}
                                                    </TableCell>

                                                </TableRow>
                                                <TableRow
                                                    key={index}
                                                >
                                                    <TableCell>
                                                        <strong>CityName:</strong> {row.address[0].CityName}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>State:</strong> {row.address[0].State}
                                                    </TableCell>
                                                    <TableCell>
                                                        <strong>Country:</strong> {row.address[0].Country}
                                                    </TableCell>
                                                    <TableCell >
                                                        <strong>Complement:</strong> {row.address[0].Complement} {row.address[0].Reference}
                                                    </TableCell>

                                                </TableRow>
                                            </>
                                        ))}
                                    </TableBody>
                                </Table>

                                <Table sx={{mt: 4}}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>SPB Bank</TableCell>
                                            <TableCell>SPB  Branch</TableCell>
                                            <TableCell>SPB Bank Account </TableCell>
                                            <TableCell>SPB Bank Account Digit</TableCell>
                                            <TableCell>AccountKey</TableCell>
                                            <TableCell>AccountStatus</TableCell>
                                            <TableCell>AccountConditionType</TableCell>
                                            <TableCell>CreationDate</TableCell>
                                            <TableCell>UpdateDate</TableCell>
                                        </TableRow>

                                    </TableHead>
                                    <TableBody>

                                        {reqData?.data_bank.map((row, index) => (
                                            <>
                                                {row?.Accounts.map(account => <TableRow>
                                                    <TableCell>{account?.SpbAccount?.Bank}</TableCell>
                                                    <TableCell>{account?.SpbAccount?.BankBranch}</TableCell>
                                                    <TableCell>{account?.SpbAccount?.BankAccount}</TableCell>
                                                    <TableCell>{account?.SpbAccount?.BankAccountDigit}</TableCell>
                                                    <TableCell>{account?.AccountKey}</TableCell>
                                                    <TableCell>{account?.AccountStatus} </TableCell>
                                                    <TableCell>{account?.AccountConditionType}</TableCell>
                                                    <TableCell>{account?.CreationDate}</TableCell>
                                                    <TableCell>{account?.UpdateDate}</TableCell>
                                        </TableRow>)}
                                            </>))}
                                    </TableBody>
                                </Table>

                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar
                            sx={{
                                bgcolor: "primary.main",
                                mr: '1rem'
                            }}
                        >
                            <PriorityHigh />
                        </Avatar>
                        {"Confirmação de Encerramento"}
                    </Box>
                </DialogTitle>
                <Divider/>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Alert severity={'warning'} sx={{mb:2}}>
                            Ao confirmar o encerramento, todos os boletos que ainda não foram pagos,
                            serão cancelados junto ao banco, e esta conta
                            será Encerrada junto ao FitBank. Atenção esse processo não poderá ser revertido.
                        </Alert>
                        Você tem certeza de que deseja encerrar a conta?
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}>
                    <Button size={'small'} onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button size={'small'} onClick={handleConfirm} variant="contained" color="primary" autoFocus>
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openDeactivate}
                onClose={() => setOpenDeactivate(false)}
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar
                            sx={{
                                bgcolor: reqData?.status === 'Desativado' ? 'success.main' : 'error.main',
                                mr: '1rem'
                            }}
                        >
                            <PowerSettingsNew />
                        </Avatar>
                        {reqData?.status === 'Desativado' ? 'Ativar Empresa' : 'Desativar Empresa'}
                    </Box>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <DialogContentText>
                        {reqData?.status === 'Desativado' ? (
                            <Alert severity="info" sx={{ mb: 2 }}>
                                Ao ativar a empresa, ela voltará a ter acesso ao sistema normalmente.
                            </Alert>
                        ) : (
                            <Alert severity="warning" sx={{ mb: 2 }}>
                                Ao desativar a empresa, ela perderá o acesso ao sistema.
                                Essa ação pode ser revertida ativando a empresa novamente.
                            </Alert>
                        )}
                        {reqData?.status === 'Desativado'
                            ? `Você tem certeza de que deseja ativar a empresa "${reqData?.name}"?`
                            : `Você tem certeza de que deseja desativar a empresa "${reqData?.name}"?`
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button size="small" onClick={() => setOpenDeactivate(false)} color="primary">
                        Cancelar
                    </Button>
                    <Button
                        size="small"
                        onClick={toggleCompanyStatus}
                        variant="contained"
                        color={reqData?.status === 'Desativado' ? 'success' : 'error'}
                        autoFocus
                    >
                        {reqData?.status === 'Desativado' ? 'Ativar' : 'Desativar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isSaving}
                // onClick={() => {
                //   if (isSaving === false){
                //     setActiveBackdrop(false)
                //   }
                //
                // }}
            >
                <CircularProgress color="inherit" />

            </Backdrop>
        </>

    )
}

export default CompanyDetail
